const PRODUCTION_BRANCH_ID = "master";
const PRODUCTION_BRANCH_NAME = "main";
const SCORECARD_LAYOUT_PATH = "UserDefinedFiles\\Scorecard\\";
const ANALYSIS_TEMPLATE_PATH = "UserDefinedFiles\\AnalysisTemplates\\";
export {
  ANALYSIS_TEMPLATE_PATH,
  PRODUCTION_BRANCH_ID,
  PRODUCTION_BRANCH_NAME,
  SCORECARD_LAYOUT_PATH
};
//# sourceMappingURL=maui.constants.js.map
